module.exports = __webpack_public_path__ + "images/logo--crown.ee4d7f922d6880c04a8c9cf5c83b8aba.png";